import { Api } from '../../../utility/client';

export async function sendUrgentAlert(roomId: string) {
  return Api.post<Response>(
    `/telesitting/v1/events/rooms/${roomId}/generalEvents`,
    {
      type: 'urgent',
    },
  );
}
